export default "<div [innerHTML]=\"privacyPolicyText\"></div>\n";